// Default form state and errors for property forms
import { DayOfWeek, MaintenanceDay } from '@/components/admin/properties/form-sections';
import { PMSType } from '@/types/admin/properties';

export const getDefaultPropertyFormState = (organizationId?: number | string) => ({
  marketingName: '',
  externalId: '',
  organizationId: organizationId?.toString() || '',
  // PMS Configuration
  pmsType: 'yardi' as PMSType,
  // Yardi Configuration
  yardiDomain: '',
  yardiUsername: '',
  yardiPassword: '',
  yardiServerName: '',
  yardiDatabase: '',
  yardiBpInterfaceEntity: 'Resio',
  yardiBpInterfaceLicense: '',
  // Card Connect Settings
  creditCardMerchantAccountId: '',
  achMerchantAccountId: '',
  // Property Details
  propertyEmailAddress: '',
  propertyPhoneNumber: '',
  propertyUrl: '',
  propertyFaqUrl: '',
  propertyResidentHandbook: '',
  propertyCbxFilePath: '',
  // Property Fees
  propertyNsfFee: '0',
  propertyLateDayStart: '5',
  propertyLateDayFee: '0',
  propertyLateDailyFee: '0',
  propertyMaxMonthlyFee: '0',
});

export const DEFAULT_PROPERTY_ERRORS = {
  marketingName: '',
  externalId: '',
  organizationId: '',
  propertyEmailAddress: '',
  propertyPhoneNumber: '',
  propertyUrl: '',
  propertyNsfFee: '',
  propertyLateDayFee: '',
  propertyLateDailyFee: '',
  propertyMaxMonthlyFee: '',
};

export const DEFAULT_MAINTENANCE_SCHEDULE: Record<DayOfWeek, MaintenanceDay> = {
  Monday: { enabled: false, startTime: '09:00', endTime: '17:00' },
  Tuesday: { enabled: false, startTime: '09:00', endTime: '17:00' },
  Wednesday: { enabled: false, startTime: '09:00', endTime: '17:00' },
  Thursday: { enabled: false, startTime: '09:00', endTime: '17:00' },
  Friday: { enabled: false, startTime: '09:00', endTime: '17:00' },
  Saturday: { enabled: false, startTime: '09:00', endTime: '17:00' },
  Sunday: { enabled: false, startTime: '09:00', endTime: '17:00' },
};

